import React from 'react'
import HorizontalStepperSecondary from '../../../../components/Stepper/HorizontalStepperSecondary'
import CUStep1Usuario from './CUStep1Usuario'
import {useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import CUStep2Sucursal from './CUStep2Sucursal'
import CUStep11Usuario from './CUStep11Usuario'

const titles = ['Información', 'Usuario', 'Sucursal']

const CrearUsuario = () => {
  const step = useSelector((state: State) => state.gestionUsuario.creacionUsuario.paginaActual)
  return (
    <>
      <div
        className='w-auto mt-16'
        style={{transform: 'scale(0.9)', margin: '0 auto', width: '30%', minWidth: '300px'}}
      >
        <HorizontalStepperSecondary titles={titles} paginaActiva={step} />
      </div>
      {step === 0 && <CUStep1Usuario />}
      {step === 1 && <CUStep11Usuario />}
      {step === 2 && <CUStep2Sucursal />}
    </>
  )
}

export default CrearUsuario
